import _Promise from "babel-runtime/core-js/promise";
import _Object$assign from "babel-runtime/core-js/object/assign";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import dict from "@/tools/dict";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";
var SAVE_PATH3 = "";
var SAVE_PATH4 = "";

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  _.set(fields, "REGISTER_FUND.IS_SHOW_CHECKBOX", true);
  _.set(fields, "REGISTER_FUND.PLACE_HOLDER", "请输入:" + fields.REGISTER_FUND.FIELD_TITLE);
  _.set(fields, "REGISTER_FUND.VALID_TYPE", "moneyExpand[12,2]");
  _.set(fields, "HAS_CORP_QUAL.FIELD_TYPE", "radio");
  _.set(fields, "INDUS_TYPE.FIELD_TYPE", "selector");
  _.set(fields, "INDUS_TYPE.FIELD_DICT", "INDUS_EXTYPE");
  _.set(fields, "INDUS_TYPE.FIELD_DICT_NAME", _this.oppBusiData.INDUS_EXTYPE_DICT);
  _.set(fields, "CORP_QUAL_ID_NAME.VALID_TYPE", "length[0,128]");
  _.set(fields, "CORP_QUAL_ID_CODE.VALID_TYPE", "length[0,48]");
  _.set(fields, "CORP_QUAL_ID_ISS_AGCY_PRO.VALID_TYPE", "length[0,256]");
  _.set(fields, "CORP_QUAL_PERMIT.VALID_TYPE", "length[0,128]");
  _.set(fields, "CITIZENSHIP.FIELD_TYPE", "selector");
  _.set(fields, "CORP_ADDR.FIELD_FUNCTION", "USE_ID_ADDRESS|CHECK_CORP_ADDR");
  _.set(fields, "SMFUND_MANAGER_ID.VALID_TYPE", "length[0,20]");
  _.set(fields, "PRO_MANAGER_BAK_DATE.VALID_TYPE", "begin");
  _.set(fields, "CORP_ADDR.VALID_TYPE", "length[16,128]");
  _.set(fields, "RISK_FACTOR.isLongItem", true);
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var managerInfo = _Object$assign({}, _.get(_this.historyData, SAVE_PATH, {}), _.get(_this.historyData, SAVE_PATH2, {}), _.get(_this.historyData, SAVE_PATH3, {}), _.get(_this.historyData, SAVE_PATH4, {}));
  managerInfo.REGISTER_CURRENCY = managerInfo.REGISTER_CURRENCY;
  managerInfo.CURRENCY_DATA_SOURCE = managerInfo.REGISTER_CURRENCY_DATA_SOURCE;

  _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], managerInfo);
  _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], managerInfo);

  if (_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.DEFAULT_VALUE == "0") {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.isCheckCheckbox = true;
  } else {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.isCheckCheckbox = false;
  }
};
var changeLegalTile = function changeLegalTile(_this, titleValue) {
  var str = "groupDatas.CONTROLER_INFO_PAGE.";
  var moduleArr = ["CONTROLER_MODULE1", "CONTROLER_MODULE", "CONTROLER_MODULE2", "BENEFICIARY_MODULE"];
  _.each(moduleArr, function (item) {
    _.set(_this, str + item + "[0].FIELDS.IS_SAME_LEGAL_REP.FIELD_TITLE", titleValue);
  });
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
    SAVE_PATH3 = params.savePath3;
    SAVE_PATH4 = params.savePath4;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    return dict.getDictData("INDUS_EXTYPE").then(function (res) {
      _this.oppBusiData.INDUS_EXTYPE_DICT = res.INDUS_EXTYPE;

      return initFieldConfig(_this);
    });
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },
  preValidate: function preValidate(_this) {
    _this.removeFlowTip("indusGbJ");
  },

  beforeSave: function beforeSave(_this, params, baseData) {
    _this.removeFlowTip("indusGbJ");

    var managerOtherInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3]);

    var baseInfo = {
      BIRTHDAY: managerOtherInfo.BIRTHDAY,
      CITIZENSHIP: managerOtherInfo.CITIZENSHIP,
      SZORG_TYPE: managerOtherInfo.SZORG_TYPE,
      REGISTER_CURRENCY: managerOtherInfo.REGISTER_CURRENCY,
      REGISTER_FUND: managerOtherInfo.REGISTER_FUND,
      SMFUND_MANAGER_ID: managerOtherInfo.SMFUND_MANAGER_ID,
      PROF_INVESTOR_SOURCE: "10"
    };

    var baseSourceInfo = {};

    _.each(baseInfo, function (value, key) {
      if (managerOtherInfo[key + "_DATA_SOURCE"]) {
        baseSourceInfo[key + "_DATA_SOURCE"] = managerOtherInfo[key + "_DATA_SOURCE"];
      }
      if (key == "ORG_ID_CODE") {
        baseSourceInfo["ORG_ID_CODE_DATA_SOURCE"] = _this.oppBusiData.hideFields.ORG_ID_CODE && _this.oppBusiData.hideFields.ORG_ID_CODE.DATA_SOURCE || "";
      }
    });

    _Object$assign(baseInfo, baseSourceInfo);

    var contactInfo = {
      ID_ZIP_CODE: managerOtherInfo.ID_ZIP_CODE,
      ID_ZIP_CODE_DATA_SOURCE: managerOtherInfo.ID_ZIP_CODE_DATA_SOURCE,
      CORP_ADDR: managerOtherInfo.CORP_ADDR,
      CORP_ADDR_DATA_SOURCE: managerOtherInfo.CORP_ADDR_DATA_SOURCE,
      PRO_SPECIAL_TAG: managerOtherInfo.PRO_SPECIAL_TAG || "",
      RISK_FACTOR: managerOtherInfo.RISK_FACTOR || ""
    };

    baseData.YZT_RISK_FACTOR = contactInfo.RISK_FACTOR || "-1";
    var extInfo = {
      HAS_CORP_QUAL: managerOtherInfo.HAS_CORP_QUAL,
      CORP_QUAL_ID_NAME: managerOtherInfo.CORP_QUAL_ID_NAME,
      CORP_QUAL_ID_CODE: managerOtherInfo.CORP_QUAL_ID_CODE,
      CORP_QUAL_ID_EXP_DATE: managerOtherInfo.CORP_QUAL_ID_EXP_DATE,
      CORP_QUAL_ID_ISS_AGCY_PRO: managerOtherInfo.CORP_QUAL_ID_ISS_AGCY_PRO,
      CORP_QUAL_PERMIT: managerOtherInfo.CORP_QUAL_PERMIT,
      INDUS_TYPE: managerOtherInfo.INDUS_TYPE,
      INDUS_GB: managerOtherInfo.INDUS_GB
    };

    var productInfo = {
      PRO_MANAGER_BAK_DATE: managerOtherInfo.PRO_MANAGER_BAK_DATE,
      PRO_MANAGER_BAK_DATE_DATA_SOURCE: managerOtherInfo.PRO_MANAGER_BAK_DATE_DATA_SOURCE
    };

    bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], baseInfo);
    bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH2], contactInfo);
    bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH3], extInfo);
    bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH4], productInfo);

    _.set(params, SAVE_PATH, _Object$assign({}, _.get(params, SAVE_PATH, {}), baseInfo));

    _.set(params, SAVE_PATH2, _Object$assign({}, _.get(params, SAVE_PATH2, {}), contactInfo));

    _.set(params, SAVE_PATH3, _Object$assign({}, _.get(params, SAVE_PATH3, {}), extInfo));

    _.set(params, SAVE_PATH4, _Object$assign({}, _.get(params, SAVE_PATH4, {}), productInfo));
  },
  validate: function validate(_this) {
    var checkAddrFlag = false;
    var address = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CORP_ADDR.DEFAULT_VALUE;
    if (address && !_this.$blMethod.checkAddress(address)) {
      checkAddrFlag = true;
    }
    if (checkAddrFlag) {
      return new _Promise(function (resolve, reject) {
        _this.confirm({
          messageText: "\u8054\u7CFB\u5730\u5740\u672A\u7CBE\u786E\u5230\u95E8\u724C\u53F7\uFF0C\u8BF7\u786E\u8BA4\u8054\u7CFB\u5730\u5740\uFF1A\u3010" + address + "\u3011\u4E3A\u771F\u5B9E\u7684\u3001\u53EF\u8054\u7CFB\u5230\u7BA1\u7406\u4EBA\u7684\u5E38\u7528\u5730\u5740\uFF0C\u53EF\u6B63\u5E38\u63D0\u4EA4\u3002",
          cancelButtonText: "修改",
          confirmButtonText: "确定",
          confirmedAction: function confirmedAction() {
            resolve(true);
          },
          canceledAction: function canceledAction() {
            resolve(false);
          }
        });
      }).then(function (res) {
        return res;
      });
    } else {
      return true;
    }
  },
  pageActivated: function pageActivated(_this) {
    if (["10", "11", "12", "13"].includes(_this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_TYPE.DEFAULT_VALUE)) {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.FIELD_CONTROL = "2";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.DEFAULT_VALUE = "CHN";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.DATA_SOURCE = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_TYPE.DATA_SOURCE;
    } else {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.FIELD_CONTROL = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CITIZENSHIP.DATA_SOURCE = "";
    }
    if (_this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.isCheckCheckbox) {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.DEFAULT_VALUE = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_REQUIRED = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_CONTROL = "2";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.VALID_TYPE = "";
    } else {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_REQUIRED = "1";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.FIELD_CONTROL = "0";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.REGISTER_FUND.VALID_TYPE = "moneyExpand[12,2]";
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  CHECK_REGISTER_FUND__CLICK: function CHECK_REGISTER_FUND__CLICK(_this, field, fieldData) {
    if (field.isCheckCheckbox) {
      field.DEFAULT_VALUE = "0";
      field.FIELD_REQUIRED = "0";
      field.FIELD_CONTROL = "2";
      field.VALID_TYPE = "";
    } else {
      field.VALID_TYPE = "moneyExpand[12,2]";
      field.DEFAULT_VALUE = "";
      field.FIELD_REQUIRED = "1";
      field.FIELD_CONTROL = "0";
    }
  },

  CHECK_HAS_CORP_QUAL: function CHECK_HAS_CORP_QUAL(_this, field, fieldData) {
    var hasCorpQual = field.DEFAULT_VALUE === "1";
    ["CORP_QUAL_ID_NAME", "CORP_QUAL_ID_CODE", "CORP_QUAL_ID_EXP_DATE", "CORP_QUAL_ID_ISS_AGCY_PRO", "CORP_QUAL_PERMIT"].map(function (fk) {
      var f = fieldData[fk];
      f.FIELD_CONTROL = hasCorpQual ? "0" : "1";
      f.FIELD_REQUIRED = hasCorpQual ? "1" : "0";
      !hasCorpQual && _.set(f, "DEFAULT_VALUE", "");
    });
  },
  CHECK_CORP_ADDR: function CHECK_CORP_ADDR(_this, field, fieldData, module) {
    _this.$nextTick(function () {
      if (!_this.oppBusiData.zipCodeList) {
        _this.oppBusiData.zipCodeList = [];
      }
      if (field.addressInfo && field.addressInfo[1] && field.addressInfo[1].length == 3) {
        var existCodeItem = _.find(_this.oppBusiData.zipCodeList, function (v) {
          return v.DICT_ITEM_NAME == field.addressInfo[1].join(",");
        });
        if (existCodeItem) {
          fieldData.ID_ZIP_CODE.DEFAULT_VALUE = existCodeItem.DICT_ITEM;
          return;
        }
        return _this.$blMethod.setZipCode(_this, field.addressInfo[1]).then(function (zipCode) {
          if (zipCode) {
            _this.oppBusiData.zipCodeList.push({
              DICT_ITEM: zipCode,
              DICT_ITEM_NAME: field.addressInfo[1].join(",")
            });
            fieldData.ID_ZIP_CODE.DEFAULT_VALUE = zipCode;
          }
        });
      }
    });
  },
  CHECK_INDUS_GB: function CHECK_INDUS_GB(_this, field, fieldData) {
    _this.removeFlowTip("indusGbJ");
    if (field.DEFAULT_VALUE == "J") {
      _this.pushFlowTip({
        title: "客户填报的行业信息为“金融业”，该行业信息可能会影响客户的基金交易，请确认信息的准确性。",
        key: "indusGbJ",
        type: "warning"
      });
    }
  },
  CHECK_CORP_ADDR__CLICK: function CHECK_CORP_ADDR__CLICK(_this, field, fieldData, module) {
    field.DEFAULT_VALUE = _.get(_this, "groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_ADDR.DEFAULT_VALUE");
  },
  CHECK_SZORG_TYPE: function CHECK_SZORG_TYPE(_this, field, fieldData) {
    if (["25", "25a", "25b"].includes(field.DEFAULT_VALUE)) {
      fieldData.SMFUND_MANAGER_ID.FIELD_CONTROL = "0";
      fieldData.PRO_MANAGER_BAK_DATE.FIELD_CONTROL = "0";
      fieldData.SMFUND_MANAGER_ID.DEFAULT_VALUE = "";
      fieldData.PRO_MANAGER_BAK_DATE.DEFAULT_VALUE = "";
    } else {
      fieldData.SMFUND_MANAGER_ID.FIELD_CONTROL = "1";
      fieldData.PRO_MANAGER_BAK_DATE.FIELD_CONTROL = "1";
    }
    var legal_rep = "groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE",
        legal_rep_fields = "groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS";

    if (["21", "22", "23", "25a"].indexOf(field.DEFAULT_VALUE) > -1) {
      _.set(_this, legal_rep + "[0].MODULE_TITLE", "管理人执行事务合伙人");
      _.set(_this, legal_rep_fields + ".LEGAL_REP.FIELD_TITLE", "执行事务合伙人");
      changeLegalTile(_this, "是否同执行事务合伙人");
    } else {
      _.set(_this, legal_rep + "[0].MODULE_TITLE", "管理人法定代表人");
      _.set(_this, legal_rep_fields + ".LEGAL_REP.FIELD_TITLE", "法定代表人");
      changeLegalTile(_this, "是否同法定代表人");
    }
  },

  CHECK_OPP_PRO_SPECIAL_TAG: function CHECK_OPP_PRO_SPECIAL_TAG(_this, field, fieldData) {
    if (field.DEFAULT_VALUE != "") {
      if (_.indexOf(["0", "1", "2"], field.DEFAULT_VALUE) != -1) {
        field.SPECIAL_MSG = "请根据产品标签选择对应的风险因素，风险因素可多选。";
        field.showerr = true;
        fieldData.RISK_FACTOR.FIELD_CONTROL = "0";
        fieldData.RISK_FACTOR.DEFAULT_VALUE = "";
        fieldData.RISK_FACTOR.FIELD_REQUIRED = "1";
      } else {
        fieldData.RISK_FACTOR.FIELD_CONTROL = "0";
        fieldData.RISK_FACTOR.DEFAULT_VALUE = "";
        fieldData.RISK_FACTOR.FIELD_REQUIRED = "0";
        field.SPECIAL_MSG = "";
        field.showerr = false;
      }
    }
  },

  CHECK_RISK_FACTOR: function CHECK_RISK_FACTOR(_this, field, fieldData) {
    var riskFactor = field.DEFAULT_VALUE && field.DEFAULT_VALUE.split(",") || [];
    if (riskFactor.length > 16) {
      field.SPECIAL_MSG = "风险因素最多选择16个";
      field.showerr = true;

      riskFactor.pop();
      fieldData.RISK_FACTOR.DEFAULT_VALUE = riskFactor || "";
    } else {
      field.SPECIAL_MSG = "";
      field.showerr = false;
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/bizPro/bizManagerOtherInfo.js
// module id = 211
// module chunks = 2